import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { t } from '../../../app/i18n';
import { Link } from 'react-router';
import Table from 'antd/lib/table';
import Select from 'antd/lib/select';
import { ResponsiveTable } from '../../../common/components/data-display';
import { helpStatusT } from '../../../common/enums';
import { Row, Col } from 'react-flexbox-grid';
import { formatDateTime } from '../../../common/utils/helpers';


const { Column } = Table;
const { Option } = Select;

const testFunction = (name, question, index, questions) => {
  if (index !== 0 && question.AccountId === questions[index - 1].AccountId) {
    return {
      children: <span style={{ marginLeft: 40 }}>&#8627;</span>,
    };
  }
  if(question.AccountId){
    return {
      children: <span><Link to={`/admin/accounts/${question.AccountId}/profile`}>{name}</Link></span>,
    };
  }
  return {
    children: <span>{name}</span>,
  };
};


@translate()
export default class QuestionList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    questions: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.func,
    token: PropTypes.string,
  };
  static defaultProps = {
    actions: (text, question) => (
      <span>
        <Link to={`/admin/help/${question.id}`}>{t('Detail')}</Link>
      </span>
    ),
  };

  render() {
    const {
      questions,
      pagination,
      filter,
      onTableChange,
      onFilterSearchChange,
      onFilterStatusChange,
      isLoading,
      actions,
      t,
      token,
    } = this.props;
    
    return (
      <div>

        <Row className="filters padded">
          {/* <Col xs={12} sm={4}>
            <Search
              key="questionSearch"
              onSearch={onFilterSearchChange}
            />
          </Col> */}
          <Col xs={12} sm={4}>
            <Select
              placeholder={t('Vybrať stav')}
              onChange={onFilterStatusChange}
              value={filter.id_status}
            >
              <Option value="">{t('Všetky stavy')}</Option>
              {Object.entries(helpStatusT).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </Col>
          
        </Row>


        <ResponsiveTable
          dataSource={questions}
          rowKey={question => question.id}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
          
        >
          <Column
            title={t('Meno')}
            dataIndex="name"
            key="name"
            render={(name, question, index) => testFunction(name, question, index, questions)}
          />
          <Column
            title={t('Email')}
            dataIndex="email"
            key="email"
            render={email => email}
        />

          <Column
            title={t('Otázka')}
            dataIndex="question"
            key="question"
            render={question => question}
          />
          <Column
            title={t('Odpoved')}
            width="160px"
            dataIndex="answer"
            key="answer"
            render={answer => answer}
          />
         
          <Column
            title={t('Stav otázky')}
            dataIndex="id_status"
            key="id_status"
            render={id_status => helpStatusT[id_status]}
          />
          
          <Column
            title={t('Dátum vytvorenia')}
            dataIndex="date_question"
            key="date_question"
            render={date_question => formatDateTime(date_question) }
          />


          <Column title={t('Akcie')} key="action" render={(text, question) => (
              <span>
                <Link to={`/admin/help/${question.id}`}>{t('Detail')}</Link>
              </span>
            )} 
          />
        </ResponsiveTable>



      </div>



    )

  }

}


// WEBPACK FOOTER //
// ./src/features/help-management/components/QuestionList.js